import { TranslationFunction } from "i18next";
import { translate } from "react-i18next";

export interface ITranslationProps {
    t: TranslationFunction;
}

export function translateComponent<T>(component: React.ComponentClass<T> | React.StatelessComponent<T>) {

    // TODO: determine namespace dynamically (from localState or cookie maybe)
    // Use this for customer-specific translations
    const namespace = "translations";

    return translate(namespace)(component);
}



// WEBPACK FOOTER //
// ./src/helpers/translation.ts